
import { Component, Vue } from 'vue-property-decorator'

import ErrorEntities, { FormValidationErrors } from '@/models/error-entities'

@Component
export default class GroupedErrorValidationMixin extends Vue {
  form: any
  rules: any
  validator: any
  formErrors: ErrorEntities = {}
  alteredValidationFieldNames: any // optional

  // `field` is the `prop` set for the validator. It should match the form param name.
  // `displayedFieldName` is the one we actually display.
  // By default displayedFieldName === field.
  handleElFormValidation(field: string, isValid: boolean) {
    const { validator, formErrors, alteredValidationFieldNames = {} } = this
    const displayedFieldName = alteredValidationFieldNames[field] || field

    if (isValid) {
      this.formErrors = { ...this.$_.omit(formErrors, displayedFieldName) }
      return
    }

    validator.validate(
      this.form,
      (_: any, errorsByField: FormValidationErrors) => {
        const validationErrors = errorsByField[field]
        this.formErrors = {
          ...formErrors,
          [displayedFieldName]: validationErrors.map((e: any) => e.message),
        }
      },
    )
  }
}
